import React from 'react';
import Hdr from '../shared/Hdr.js';
import TopBanner from '../components/TopBanner.js';
import Overview from '../Dashboard/Overview.js';
import PendingDoc from '../Dashboard/PendingDocs.js';
import ApprovedDocs from '../Dashboard/ApprovedDocs.js';
import RejectedDocs from '../Dashboard/RejectedDocs.js';
import OntransitDocs from '../Dashboard/OntransitDocs.js';
import InventorySumByStore from '../Dashboard/InventorySumByStore.js';
import InvValToolTypeSummary2 from '../Charts/InvValToolType_summary2.js';

export default function Dashboard() {
	const useRoleName = localStorage.getItem('user-role');
	const isAdmin = ["Administrator", "Top Management", "Department Incharge"].includes(useRoleName);

	return (
		<>
			<Hdr />
			<TopBanner name={'Dashboard '} />

			<div className="cont__dashboard ">
				<div>
					<Overview />
				</div>

				<div className="row mt16">
					<InventorySumByStore />
					<div className="cont_dashboard-doc-counts">
						<PendingDoc />
						<ApprovedDocs />
						<RejectedDocs />
						<OntransitDocs />
					</div>
				</div>
			</div>
		</>
	);
}
